import useVodPopup from '@/pages/function/hook/useVodPopup';

const VodPopup = () => {
	useVodPopup();
	return (
		<div className="popup">
			<div className="popup-vod">
				<button type="button" className="popup-close" title="영상 팝업 닫기"></button>
				<div className="vod-wrap">
					<iframe
						width="960"
						height="540"
						src=""
						frameBorder="0"
						allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
						referrerPolicy="strict-origin-when-cross-origin"
						allowFullScreen></iframe>
				</div>
			</div>
		</div>
	);
};

export default VodPopup;
